"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3978],{

/***/ 353978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "s": function() { return /* binding */ getThemeComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(626042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(269396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(785893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(505152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(506337);
;// CONCATENATED MODULE: ./src/utils/commonWidgetFn.js

var isRedirectedFromWebsiteBuilder = function() {
    if (!checkRenderEnv/* IS_SERVER */.W6) {
        var ref;
        var currentUrl = window === null || window === void 0 ? void 0 : (ref = window.location) === null || ref === void 0 ? void 0 : ref.href;
        var searchString = "/widgets/dnd";
        return currentUrl === null || currentUrl === void 0 ? void 0 : currentUrl.includes(searchString);
    } else {
        return false;
    }
};

// EXTERNAL MODULE: ./src/constants/widgets.ts
var widgets = __webpack_require__(442381);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/NewAnnouncementBar/index.tsx + 3 modules
var NewAnnouncementBar = __webpack_require__(990807);
;// CONCATENATED MODULE: ./src/utils/themeImports.js




var LaunchingSoon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3948).then(__webpack_require__.bind(__webpack_require__, 273948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(273948)
            ];
        }
    }
});
var Header1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2891).then(__webpack_require__.bind(__webpack_require__, 142891));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(142891)
            ];
        }
    }
});
var Header2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7122), __webpack_require__.e(7556)]).then(__webpack_require__.bind(__webpack_require__, 577556));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(577556)
            ];
        }
    }
});
var Header3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7122), __webpack_require__.e(7872)]).then(__webpack_require__.bind(__webpack_require__, 947872));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(947872)
            ];
        }
    }
});
var Header7 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7122), __webpack_require__.e(824)]).then(__webpack_require__.bind(__webpack_require__, 640824));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(640824)
            ];
        }
    }
});
var Header8 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5025), __webpack_require__.e(1169)]).then(__webpack_require__.bind(__webpack_require__, 152264));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(152264)
            ];
        }
    }
});
var Header9 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5025), __webpack_require__.e(9002)]).then(__webpack_require__.bind(__webpack_require__, 409002));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(409002)
            ];
        }
    }
});
var Header10 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6863), __webpack_require__.e(9706)]).then(__webpack_require__.bind(__webpack_require__, 729706));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(729706)
            ];
        }
    }
});
var Header11 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6863), __webpack_require__.e(7101)]).then(__webpack_require__.bind(__webpack_require__, 247101));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(247101)
            ];
        }
    }
});
var Header12 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6863), __webpack_require__.e(3829)]).then(__webpack_require__.bind(__webpack_require__, 193829));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(193829)
            ];
        }
    }
});
var Header14 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6863), __webpack_require__.e(846)]).then(__webpack_require__.bind(__webpack_require__, 480846));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(480846)
            ];
        }
    }
});
// Sub Header ( Hello Bar)
var SubHeader1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9716).then(__webpack_require__.bind(__webpack_require__, 39716));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39716)
            ];
        }
    }
});
var SubHeader2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7147).then(__webpack_require__.bind(__webpack_require__, 157147));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(157147)
            ];
        }
    }
});
var SubHeader3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6437).then(__webpack_require__.bind(__webpack_require__, 306437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(306437)
            ];
        }
    }
});
var SubHeader4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1694).then(__webpack_require__.bind(__webpack_require__, 681694));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(681694)
            ];
        }
    }
});
// Hello Bar ( This now replaces all previous subHeaders)
var SubHeader = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6485), __webpack_require__.e(7162)]).then(__webpack_require__.bind(__webpack_require__, 559351));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(559351)
            ];
        }
    }
});
// Hero banner
var HeroBanner1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7883)]).then(__webpack_require__.bind(__webpack_require__, 847883));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(847883)
            ];
        }
    }
});
var HeroBanner2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(9622)]).then(__webpack_require__.bind(__webpack_require__, 389622));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(389622)
            ];
        }
    }
});
var HeroBanner3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3020)]).then(__webpack_require__.bind(__webpack_require__, 113020));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(113020)
            ];
        }
    }
});
var HeroBanner4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(7675)]).then(__webpack_require__.bind(__webpack_require__, 147675));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(147675)
            ];
        }
    }
});
var HeroBanner5 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(9907)]).then(__webpack_require__.bind(__webpack_require__, 239907));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(239907)
            ];
        }
    }
});
var HeroBanner6 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(5998)]).then(__webpack_require__.bind(__webpack_require__, 25998));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25998)
            ];
        }
    }
});
var HeroBanner7 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8932)]).then(__webpack_require__.bind(__webpack_require__, 28932));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28932)
            ];
        }
    }
});
var HeroBanner8 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8496)]).then(__webpack_require__.bind(__webpack_require__, 708496));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(708496)
            ];
        }
    }
});
var HeroBanner9 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6854)]).then(__webpack_require__.bind(__webpack_require__, 916854));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(916854)
            ];
        }
    }
});
// Middle Body
var MiddleBody1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(1842)]).then(__webpack_require__.bind(__webpack_require__, 311842));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(311842)
            ];
        }
    }
});
var MiddleBody2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(3972)]).then(__webpack_require__.bind(__webpack_require__, 23972));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23972)
            ];
        }
    }
});
var MiddleBody3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(2187)]).then(__webpack_require__.bind(__webpack_require__, 302187));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(302187)
            ];
        }
    }
});
var MiddleBody4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(4751)]).then(__webpack_require__.bind(__webpack_require__, 424751));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(424751)
            ];
        }
    }
});
var MiddleBody5 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(448), __webpack_require__.e(9996), __webpack_require__.e(3410), __webpack_require__.e(7198), __webpack_require__.e(8714)]).then(__webpack_require__.bind(__webpack_require__, 348704));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(348704)
            ];
        }
    }
});
var MiddleBody6 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(448), __webpack_require__.e(9996), __webpack_require__.e(3410), __webpack_require__.e(945)]).then(__webpack_require__.bind(__webpack_require__, 542501));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(542501)
            ];
        }
    }
});
var PromoList1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(2352)]).then(__webpack_require__.bind(__webpack_require__, 652352));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(652352)
            ];
        }
    }
});
var PromoList2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(4365)]).then(__webpack_require__.bind(__webpack_require__, 244365));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(244365)
            ];
        }
    }
});
var PromoList3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(9923)]).then(__webpack_require__.bind(__webpack_require__, 729923));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(729923)
            ];
        }
    }
});
var PromoList4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(2857)]).then(__webpack_require__.bind(__webpack_require__, 772857));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(772857)
            ];
        }
    }
});
var PromoList5 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1675), __webpack_require__.e(602)]).then(__webpack_require__.bind(__webpack_require__, 480602));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(480602)
            ];
        }
    }
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(3767)]).then(__webpack_require__.bind(__webpack_require__, 913767));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(913767)
            ];
        }
    }
});
var Footer1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(8556)]).then(__webpack_require__.bind(__webpack_require__, 818556));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(818556)
            ];
        }
    }
});
var Footer2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5025), __webpack_require__.e(350)]).then(__webpack_require__.bind(__webpack_require__, 980350));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(980350)
            ];
        }
    }
});
var Footer3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5442).then(__webpack_require__.bind(__webpack_require__, 795442));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(795442)
            ];
        }
    }
});
var CLHaveSomthingInMind = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6196).then(__webpack_require__.bind(__webpack_require__, 6196));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6196)
            ];
        }
    }
});
var EmptyWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4405).then(__webpack_require__.bind(__webpack_require__, 614405));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(614405)
            ];
        }
    }
});
// Category Widget
var CategoryWidget1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(7401)]).then(__webpack_require__.bind(__webpack_require__, 57401));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(57401)
            ];
        }
    }
});
var CategoryWidget2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2934), __webpack_require__.e(6544)]).then(__webpack_require__.bind(__webpack_require__, 436544));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(436544)
            ];
        }
    }
});
var CategoryWidget3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(6490)]).then(__webpack_require__.bind(__webpack_require__, 616490));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(616490)
            ];
        }
    }
});
var CategoryWidget4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2934), __webpack_require__.e(1572)]).then(__webpack_require__.bind(__webpack_require__, 691572));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(691572)
            ];
        }
    }
});
var CategoryWidget7 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(9135)]).then(__webpack_require__.bind(__webpack_require__, 69135));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69135)
            ];
        }
    }
});
var CategoryWidget8 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2934), __webpack_require__.e(6468)]).then(__webpack_require__.bind(__webpack_require__, 596468));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(596468)
            ];
        }
    }
});
var CategoryWidget9 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7838).then(__webpack_require__.bind(__webpack_require__, 967838));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(967838)
            ];
        }
    }
});
var CategoryWidget10 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(2692)]).then(__webpack_require__.bind(__webpack_require__, 132692));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(132692)
            ];
        }
    }
});
var CategoryWidget11 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8793), __webpack_require__.e(8060)]).then(__webpack_require__.bind(__webpack_require__, 278060));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(278060)
            ];
        }
    }
});
var CategoryWidget12 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2934), __webpack_require__.e(3098)]).then(__webpack_require__.bind(__webpack_require__, 243098));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(243098)
            ];
        }
    }
});
var CategoryWidget13 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7268), __webpack_require__.e(7437)]).then(__webpack_require__.bind(__webpack_require__, 457437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(457437)
            ];
        }
    }
});
var CategoryWidget14 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9746), __webpack_require__.e(7170)]).then(__webpack_require__.bind(__webpack_require__, 807170));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(807170)
            ];
        }
    }
});
var CategoryWidget15 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7268), __webpack_require__.e(7610)]).then(__webpack_require__.bind(__webpack_require__, 187610));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(187610)
            ];
        }
    }
});
var CategoryWidget16 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9746), __webpack_require__.e(2042)]).then(__webpack_require__.bind(__webpack_require__, 682042));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(682042)
            ];
        }
    }
});
var CategoryHeader1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4483).then(__webpack_require__.bind(__webpack_require__, 554483));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(554483)
            ];
        }
    }
});
var CategoryHeader2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4381).then(__webpack_require__.bind(__webpack_require__, 684381));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(684381)
            ];
        }
    }
});
var CategoryHeader3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7979).then(__webpack_require__.bind(__webpack_require__, 367979));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(367979)
            ];
        }
    }
});
// CategoryHeader4,
// CategoryHeader5,
var CollectionWidget1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4546).then(__webpack_require__.bind(__webpack_require__, 724546));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(724546)
            ];
        }
    }
});
var CollectionCategoryProductWidget1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(9996), __webpack_require__.e(7650)]).then(__webpack_require__.bind(__webpack_require__, 747650));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(747650)
            ];
        }
    }
});
var DisclaimerWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1026).then(__webpack_require__.bind(__webpack_require__, 791026));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(791026)
            ];
        }
    }
});
var CategoryProducsDisplayWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5675), __webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(437), __webpack_require__.e(9719), __webpack_require__.e(6499), __webpack_require__.e(9996), __webpack_require__.e(2287), __webpack_require__.e(4505), __webpack_require__.e(2755), __webpack_require__.e(1013)]).then(__webpack_require__.bind(__webpack_require__, 493247));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(493247)
            ];
        }
    }
});
var AdvanceCatalogMiddleBody = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3662), __webpack_require__.e(4434), __webpack_require__.e(6379), __webpack_require__.e(6246), __webpack_require__.e(4914), __webpack_require__.e(8738), __webpack_require__.e(9996), __webpack_require__.e(9142), __webpack_require__.e(7540)]).then(__webpack_require__.bind(__webpack_require__, 369142));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(369142)
            ];
        }
    }
});
var JsonPageBuilderWidget = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3641).then(__webpack_require__.bind(__webpack_require__, 313641)).then(function(mod) {
        return mod.JsonPageBuilderWidget;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(313641)
            ];
        }
    }
});
var AdditionalPage = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(531), __webpack_require__.e(9719), __webpack_require__.e(6499), __webpack_require__.e(2287), __webpack_require__.e(7858)]).then(__webpack_require__.bind(__webpack_require__, 759108));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(759108)
            ];
        }
    }
});
/**                       Modern Hero Banner Themes                               */ /**  Modern Hero Banners  */ var ModernHeroBanner1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5960).then(__webpack_require__.bind(__webpack_require__, 405960));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(405960)
            ];
        }
    }
});
var ModernHeroBanner2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6134).then(__webpack_require__.bind(__webpack_require__, 86134));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86134)
            ];
        }
    }
});
var ModernHeroBanner3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6982).then(__webpack_require__.bind(__webpack_require__, 236982));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(236982)
            ];
        }
    }
});
var ModernHeroBanner4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7168).then(__webpack_require__.bind(__webpack_require__, 717168));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(717168)
            ];
        }
    }
});
var ModernHeroBanner5 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8694).then(__webpack_require__.bind(__webpack_require__, 908694));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(908694)
            ];
        }
    }
});
var ModernHeroBanner6 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1203).then(__webpack_require__.bind(__webpack_require__, 381203));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(381203)
            ];
        }
    }
});
/**  Modern Middle Body 2-Column  */ var ModernMiddleBodyColumn1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5558).then(__webpack_require__.bind(__webpack_require__, 25558));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25558)
            ];
        }
    }
});
var ModernMiddleBodyColumn2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2281).then(__webpack_require__.bind(__webpack_require__, 222281));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(222281)
            ];
        }
    }
});
var ModernMiddleBodyColumn3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6288).then(__webpack_require__.bind(__webpack_require__, 386288));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(386288)
            ];
        }
    }
});
var ModernMiddleBodyColumn4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2677).then(__webpack_require__.bind(__webpack_require__, 852677));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(852677)
            ];
        }
    }
});
var ModernMiddleBodyColumn5 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7489).then(__webpack_require__.bind(__webpack_require__, 497489));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(497489)
            ];
        }
    }
});
var ModernMiddleBodyColumn6 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3275).then(__webpack_require__.bind(__webpack_require__, 463275));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(463275)
            ];
        }
    }
});
/**  Modern Middle Body Gallery  */ var ModernMiddleBodyGallery1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8460).then(__webpack_require__.bind(__webpack_require__, 771892));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(771892)
            ];
        }
    }
});
var ModernMiddleBodyGallery2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8955).then(__webpack_require__.bind(__webpack_require__, 688955));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(688955)
            ];
        }
    }
});
var ModernMiddleBodyGallery3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9990).then(__webpack_require__.bind(__webpack_require__, 519990));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(519990)
            ];
        }
    }
});
var ModernMiddleBodyGallery4 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5900).then(__webpack_require__.bind(__webpack_require__, 925900));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(925900)
            ];
        }
    }
});
var ModernMiddleBodyGallery5 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4096).then(__webpack_require__.bind(__webpack_require__, 974096));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(974096)
            ];
        }
    }
});
var ModernMiddleBodyGallery6 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 634).then(__webpack_require__.bind(__webpack_require__, 880634));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(880634)
            ];
        }
    }
});
var ModernMiddleBodyGallery7 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2958).then(__webpack_require__.bind(__webpack_require__, 32958));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32958)
            ];
        }
    }
});
var ModernMiddleBodyGallery8 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9673).then(__webpack_require__.bind(__webpack_require__, 959673));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(959673)
            ];
        }
    }
});
var ModernHeader1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6536).then(__webpack_require__.bind(__webpack_require__, 876536));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(876536)
            ];
        }
    }
});
/**  Modern Middle Body Tabs     */ var ModernMiddleBodyTab1 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2988).then(__webpack_require__.bind(__webpack_require__, 402988));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(402988)
            ];
        }
    }
});
var ModernMiddleBodyTab2 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6288), __webpack_require__.e(9658)]).then(__webpack_require__.bind(__webpack_require__, 869658));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(869658)
            ];
        }
    }
});
var ModernMiddleBodyTab3 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7657).then(__webpack_require__.bind(__webpack_require__, 737657));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(737657)
            ];
        }
    }
});
var ModernFooter1 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6035), __webpack_require__.e(5790)]).then(__webpack_require__.bind(__webpack_require__, 66035));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66035)
            ];
        }
    }
});
var ModernFooter2 = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3411).then(__webpack_require__.bind(__webpack_require__, 903411));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(903411)
            ];
        }
    }
});
var ModernFooter3 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3411), __webpack_require__.e(6035), __webpack_require__.e(9928)]).then(__webpack_require__.bind(__webpack_require__, 99928));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99928)
            ];
        }
    }
});
var ModernFooter4 = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3411), __webpack_require__.e(6035), __webpack_require__.e(2426)]).then(__webpack_require__.bind(__webpack_require__, 912426));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(912426)
            ];
        }
    }
});
var ModernMiddleBodyMaps = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6238).then(__webpack_require__.bind(__webpack_require__, 216238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(216238)
            ];
        }
    }
});
var NewHeaderComponent = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 950479)).then(function(mod) {
        return mod.NewHeaderWrapper;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(950479)
            ];
        }
    }
});
var NewHeroBanner = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(5675), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(5063)]).then(__webpack_require__.bind(__webpack_require__, 699170)).then(function(mod) {
        return mod.CarouselWidget;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(699170)
            ];
        }
    }
});
var RichTextWithImageWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(1849)]).then(__webpack_require__.bind(__webpack_require__, 299849));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(299849)
            ];
        }
    }
});
var RichTextWidget = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(3749)]).then(__webpack_require__.bind(__webpack_require__, 524681));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(524681)
            ];
        }
    }
});
var NewFooterComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6911), __webpack_require__.e(1509), __webpack_require__.e(373), __webpack_require__.e(666), __webpack_require__.e(9455), __webpack_require__.e(5275)]).then(__webpack_require__.bind(__webpack_require__, 819455));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(819455)
            ];
        }
    }
});
var ListPresentation = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9719), __webpack_require__.e(6499), __webpack_require__.e(2287), __webpack_require__.e(3383)]).then(__webpack_require__.bind(__webpack_require__, 276551));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(276551)
            ];
        }
    }
});



var WhatsappFloatingIcon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 906).then(__webpack_require__.bind(__webpack_require__, 530906));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(530906)
            ];
        }
    }
});
function isWrongHeaderConfigPresent(type, name) {
    if ((type === null || type === void 0 ? void 0 : type.includes("CollectionHeaderDropdownWidget")) || (name === null || name === void 0 ? void 0 : name.includes("CollectionHeaderDropdownWidget"))) {
        return true;
    }
    return false;
}
var getThemeComponent = function(type, name, props) {
    // This check is for stores with wrong config set due to an earlier bug, this sets the most used header type
    if (isWrongHeaderConfigPresent(type, name)) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header12, (0,_object_spread/* default */.Z)({}, props));
    }
    switch(type){
        case "Header":
            if (name === "Header1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header1, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: true
            }, props));
            if (name === "Header2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header2, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: true
            }, props));
            if (name === "Header3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header3, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: true
            }, props));
            if (name === "Header4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header1, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: false
            }, props));
            if (name === "Header5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header2, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: false
            }, props));
            if (name === "Header6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header3, (0,_object_spread/* default */.Z)({
                showStoreNameOnMobile: false
            }, props));
            if (name === "Header7") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header7, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header8") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header8, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header9") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header9, (0,_object_spread/* default */.Z)({}, props)); // this is for non premium users in desktop web showcase
            if (name === "Header10") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header10, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header11") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header11, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header12") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header12, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Header13") // Custom requirement for a merchant
            // show Categories props is used for either remove or change pages name in navigation header
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header8, (0,_object_spread/* default */.Z)({
                showCategories: true
            }, props));
            if (name === "Header14") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Header14, (0,_object_spread/* default */.Z)({}, props));
            if (name === "NewHeader") return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeaderComponent, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "HeroBanner":
            if (name === "HeroBanner1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner5, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner6, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner7") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner7, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner8") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner8, (0,_object_spread/* default */.Z)({}, props));
            if (name === "HeroBanner9") return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner9, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "Carousel":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeroBanner, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                forNewCarousel: false
            }));
        case widgets/* ADMIN_WIDGETS.HERO_BANNER.type */.Pe.HERO_BANNER.type:
        case widgets/* ADMIN_WIDGETS.SLIDESHOW.type */.Pe.SLIDESHOW.type:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewHeroBanner, (0,_object_spread/* default */.Z)({}, props));
        case "SubHeader":
            if (name === "SubHeader1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "SubHeader2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "SubHeader3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "SubHeader4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader4, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case widgets/* ADMIN_WIDGETS.RICH_TEXT_WITH_IMAGE.type */.Pe.RICH_TEXT_WITH_IMAGE.type:
            return (props === null || props === void 0 ? void 0 : props.isVisible) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWithImageWidget, (0,_object_spread/* default */.Z)({}, props)) : null;
        case widgets/* ADMIN_WIDGETS.RICH_TEXT.type */.Pe.RICH_TEXT.type:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(RichTextWidget, (0,_object_spread/* default */.Z)({}, props));
        case widgets/* ADMIN_WIDGETS.WHATSAPP_FLOATING_ICON.type */.Pe.WHATSAPP_FLOATING_ICON.type:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappFloatingIcon, (0,_object_spread/* default */.Z)({}, props));
        case "HelloBar":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SubHeader, (0,_object_spread/* default */.Z)({}, props));
        case widgets/* ADMIN_WIDGETS.CATEGORY.name */.Pe.CATEGORY.name:
        case widgets/* ADMIN_WIDGETS.COLLECTIONS.name */.Pe.COLLECTIONS.name:
        case widgets/* ADMIN_WIDGETS.INSTAGRAM_REELS.name */.Pe.INSTAGRAM_REELS.name:
        case widgets/* ADMIN_WIDGETS.FEATURED_COLLECTIONS.name */.Pe.FEATURED_COLLECTIONS.name:
        case widgets/* ADMIN_WIDGETS.FEATURED_CATEGORIES.name */.Pe.FEATURED_CATEGORIES.name:
        case widgets/* ADMIN_WIDGETS.FEATURED_TAGS.name */.Pe.FEATURED_TAGS.name:
        case widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_ICON.name */.Pe.MULTI_COLUMN_WITH_ICON.name:
        case widgets/* ADMIN_WIDGETS.MULTI_COLUMN_WITH_IMAGE.name */.Pe.MULTI_COLUMN_WITH_IMAGE.name:
        case widgets/* ADMIN_WIDGETS.LOGO_SLIDER.name */.Pe.LOGO_SLIDER.name:
        case widgets/* ADMIN_WIDGETS.FEATURED_REELS.name */.Pe.FEATURED_REELS.name:
        case widgets/* ADMIN_WIDGETS.BLOG_WIDGET.name */.Pe.BLOG_WIDGET.name:
        case widgets/* ADMIN_WIDGETS.TESTIMONIALS.name */.Pe.TESTIMONIALS.name:
        case widgets/* ADMIN_WIDGETS.GALLERY.name */.Pe.GALLERY.name:
        case widgets/* ADMIN_WIDGETS.PRODUCT_TESTIMONIALS.name */.Pe.PRODUCT_TESTIMONIALS.name:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ListPresentation, (0,_object_spread/* default */.Z)({}, props));
        case widgets/* ADMIN_WIDGETS.NEW_ANNOUNCEMENT_BAR.name */.Pe.NEW_ANNOUNCEMENT_BAR.name:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewAnnouncementBar/* NewAnnouncementBar */.g, (0,_object_spread/* default */.Z)({}, props));
        case "MiddleBody":
            if (name === "MiddleBody1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "MiddleBody2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "MiddleBody3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "MiddleBody4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "MiddleBody5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody5, (0,_object_spread/* default */.Z)({}, props));
            /* This check for Middlebody6 is used as a hack for MiddleBody6 freeze issue in Website Builder */ if (name === "MiddleBody6" && isRedirectedFromWebsiteBuilder()) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6, (0,_object_spread/* default */.Z)({
                    displayMiddleBodyInWebsiteBuilder: true
                }, props));
            } else {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6, (0,_object_spread/* default */.Z)({}, props));
            }
        case "SortingAndFilterWidget":
            if (name === "SortingAndFilterWidget1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdvanceCatalogMiddleBody, (0,_object_spread/* default */.Z)({}, props));
            if (name === "SortingAndFilterWidget2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody5, (0,_object_spread/* default */.Z)({
                sortAndFiltersEnabled: true
            }, props));
            if (name === "SortingAndFilterWidget3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                sortAndFiltersEnabled: true
            }));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "Footer":
            if (name === "Footer") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Footer1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Footer2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Footer3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "Footer4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer3, (0,_object_spread/* default */.Z)({
                includeCollectionSet: true
            }, props));
            if (name === widgets/* ADMIN_WIDGETS.FOOTER.type */.Pe.FOOTER.type) return /*#__PURE__*/ (0,jsx_runtime.jsx)(NewFooterComponent, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "Offers":
            if (name === "PromoList1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "PromoList2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "PromoList3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "PromoList4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "PromoList5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoList5, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "CreateList":
            if (name === "CreateList") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CLHaveSomthingInMind, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "StaticWidget":
            if (name === "StaticWidget") return /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyWidget, (0,_object_spread/* default */.Z)({}, props));
            if (name === "DisclaimerStaticWidget") return /*#__PURE__*/ (0,jsx_runtime.jsx)(DisclaimerWidget, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "CategoryWidget":
            if (name === "CategoryWidget1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget7") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget7, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget8") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget8, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget9") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget9, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget10") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget10, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget11") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget11, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget12") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget12, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget13") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget13, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget14") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget14, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                headerFixedToTop: true
            }));
            if (name === "CategoryWidget15") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget15, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryWidget16") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryWidget16, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                headerFixedToTop: true
            }));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "CategoryProductWidget":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryProducsDisplayWidget, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                widgetName: name
            }));
        case "CategoryHeaderWidget":
            if (name === "CategoryHeader1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryHeader2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryHeader3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryHeader4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "CategoryHeader5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryHeader3, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "AdditionalPageWidget":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(AdditionalPage, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                source: "home"
            }));
        case "CollectionWidget":
            if (name === "CollectionWidget1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionWidget1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                cardType: 1
            }));
            if (name === "CollectionWidget2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionWidget1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                cardType: 2
            }));
            if (name === "CollectionWidget3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionWidget1, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                cardType: 1
            }));
        case "CollectionCategoryProductWidget":
            if (name === "CollectionCategoryProductWidget1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionCategoryProductWidget1, (0,_object_spread/* default */.Z)({}, props));
        case "JsonPageWidget":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(JsonPageBuilderWidget, (0,_object_spread/* default */.Z)({}, props));
        case "LaunchingSoon":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LaunchingSoon, (0,_object_spread/* default */.Z)({}, props));
        /* Modern Theme Components - Brand Websites */ case "ModernHeroBanner":
            if (name === "ModernHeroBanner1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner5, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernHeroBanner6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeroBanner6, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernMiddleBodyColumn":
            if (name === "ModernMiddleBodyColumn1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn5, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyColumn6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyColumn6, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernMiddleBodyGallery":
            if (name === "ModernMiddleBodyGallery1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery4, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery5") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery5, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery6") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery6, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery7") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery7, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyGallery8") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyGallery8, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernMiddleBodyTabs":
            if (name === "ModernMiddleBodyTab1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyTab1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyTab2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyTab2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernMiddleBodyTab3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyTab3, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernHeader":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernHeader1, (0,_object_spread/* default */.Z)({}, props));
        case "ModernFooter":
            if (name === "ModernFooter1") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernFooter1, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernFooter2") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernFooter2, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernFooter3") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernFooter3, (0,_object_spread/* default */.Z)({}, props));
            if (name === "ModernFooter4") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernFooter4, (0,_object_spread/* default */.Z)({}, props));
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        case "ModernMiddleBodyMaps":
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(ModernMiddleBodyMaps, (0,_object_spread/* default */.Z)({}, props));
        default:
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
};


/***/ })

}]);